
export const dateTimeFormat = "YYYY-MM-DD hh:mm:ss"
export const dateFormat = "YYYY-MM-DD"
export const dc_distribution_center = [
  {
    dc_id: 100,
    dc_name: "Irving",
    owned_inventory_ind: "Y",
    inbound_receiving_ind: "Y",
    outbound_fulfillment_ind: "Y",
    returns_processing_ind: "Y",
    third_party_returns_ind: "Y",
    inventory_transfers_ind: "Y",
    dc_address: "2205 East Pionner drive",
    dc_city: "Dallas",
    dc_state: "TX",
    dc_zipcode: "75061",
    dc_country: "USA",
  },
  {
    dc_id: 101,
    dc_name: "Clarksville",
    owned_inventory_ind: "Y",
    inbound_receiving_ind: "N",
    outbound_fulfillment_ind: "Y",
    returns_processing_ind: "N",
    third_party_returns_ind: "N",
    inventory_transfers_ind: "Y",
    dc_address: "2205 East Pionner drive",
    dc_city: "Dallas",
    dc_state: "Texas",
    dc_zipcode: "75061",
    dc_country: "USA",
  },
  {
    dc_id: 102,
    dc_name: "Ambassador",
    owned_inventory_ind: "Y",
    inbound_receiving_ind: "Y",
    outbound_fulfillment_ind: "N",
    returns_processing_ind: "N",
    third_party_returns_ind: "N",
    inventory_transfers_ind: "Y",
    dc_address: "2205 East Pionner drive",
    dc_city: "Dallas",
    dc_state: "Texas",
    dc_zipcode: "75061",
    dc_country: "USA",
  },
  {
    dc_id: 200,
    dc_name: "FBA-Amazon",
    owned_inventory_ind: "Y",
    inbound_receiving_ind: "N",
    outbound_fulfillment_ind: "Y",
    returns_processing_ind: "N",
    third_party_returns_ind: "N",
    inventory_transfers_ind: "Y",
    dc_address: "2205 East Pionner drive",
    dc_city: "Dallas",
    dc_state: "Texas",
    dc_zipcode: "75061",
    dc_country: "USA",
  },
  {
    dc_id: 300,
    dc_name: "FBS-Dropship",
    owned_inventory_ind: "N",
    inbound_receiving_ind: "N",
    outbound_fulfillment_ind: "Y",
    returns_processing_ind: "N",
    third_party_returns_ind: "N",
    inventory_transfers_ind: "N",
    dc_address: "2205 East Pionner drive",
    dc_city: "Dallas",
    dc_state: "Texas",
    dc_zipcode: "75061",
    dc_country: "USA",
  },
];
